import { multiCaseGet } from 'libs/format';

export function getGoogleLocationProviderSettings(providerServiceSettings) {
  return providerServiceSettings.filter(
    (providerServiceSetting) =>
      multiCaseGet(providerServiceSetting, 'provider') === 'Google' &&
      multiCaseGet(providerServiceSetting, 'serviceType') === 'Location',
  );
}

export function getGoogleLocationProviderSetting(locationSettings, gmbLocation) {
  const setting = locationSettings.find((locationSetting) => {
    return (
      multiCaseGet(locationSetting, 'serviceData.gmbLocationId') ===
      multiCaseGet(gmbLocation, 'locationId')
    );
  });
  return setting || {};
}

export function getGoogleProfileProviderSetting(providerServiceSettings) {
  return providerServiceSettings.find(
    (providerServiceSetting) =>
      multiCaseGet(providerServiceSetting, 'provider') === 'Google' &&
      multiCaseGet(providerServiceSetting, 'serviceType') === 'Profile',
  );
}
